/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { StatementRequestModel } from '../models';
// @ts-ignore
import type { StatementType } from '../models';
/**
 * StatementGenerationApi - axios parameter creator
 * @export
 */
export const StatementGenerationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Generate patient or guarantor statement
         * @param {StatementType} statementType 
         * @param {StatementRequestModel} statementRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateStatement: async (statementType: StatementType, statementRequestModel: StatementRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'statementType' is not null or undefined
            assertParamExists('generateStatement', 'statementType', statementType)
            // verify required parameter 'statementRequestModel' is not null or undefined
            assertParamExists('generateStatement', 'statementRequestModel', statementRequestModel)
            const localVarPath = `/api/v1/statement/{statementType}`
                .replace(`{${"statementType"}}`, encodeURIComponent(String(statementType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statementRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatementGenerationApi - functional programming interface
 * @export
 */
export const StatementGenerationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatementGenerationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Generate patient or guarantor statement
         * @param {StatementType} statementType 
         * @param {StatementRequestModel} statementRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateStatement(statementType: StatementType, statementRequestModel: StatementRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateStatement(statementType, statementRequestModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatementGenerationApi.generateStatement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatementGenerationApi - factory interface
 * @export
 */
export const StatementGenerationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatementGenerationApiFp(configuration)
    return {
        /**
         * 
         * @summary Generate patient or guarantor statement
         * @param {StatementGenerationApiGenerateStatementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateStatement(requestParameters: StatementGenerationApiGenerateStatementRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.generateStatement(requestParameters.statementType, requestParameters.statementRequestModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatementGenerationApi - interface
 * @export
 * @interface StatementGenerationApi
 */
export interface StatementGenerationApiInterface {
    /**
     * 
     * @summary Generate patient or guarantor statement
     * @param {StatementGenerationApiGenerateStatementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementGenerationApiInterface
     */
    generateStatement(requestParameters: StatementGenerationApiGenerateStatementRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

}

/**
 * Request parameters for generateStatement operation in StatementGenerationApi.
 * @export
 * @interface StatementGenerationApiGenerateStatementRequest
 */
export interface StatementGenerationApiGenerateStatementRequest {
    /**
     * 
     * @type {StatementType}
     * @memberof StatementGenerationApiGenerateStatement
     */
    readonly statementType: StatementType

    /**
     * 
     * @type {StatementRequestModel}
     * @memberof StatementGenerationApiGenerateStatement
     */
    readonly statementRequestModel: StatementRequestModel
}

/**
 * StatementGenerationApi - object-oriented interface
 * @export
 * @class StatementGenerationApi
 * @extends {BaseAPI}
 */
export class StatementGenerationApi extends BaseAPI implements StatementGenerationApiInterface {
    /**
     * 
     * @summary Generate patient or guarantor statement
     * @param {StatementGenerationApiGenerateStatementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatementGenerationApi
     */
    public generateStatement(requestParameters: StatementGenerationApiGenerateStatementRequest, options?: RawAxiosRequestConfig) {
        return StatementGenerationApiFp(this.configuration).generateStatement(requestParameters.statementType, requestParameters.statementRequestModel, options).then((request) => request(this.axios, this.basePath));
    }
}

